import { Button } from "@/components/ui/button";
import { PixelLoader } from "@/components/ui/pixel-loader";
import type { ReactNode } from "react";
import ResponsiveModal from "./ResponsiveModal";

interface ConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string | ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  variant?: "default" | "destructive";
  isLoading?: boolean;
}

export default function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  variant = "default",
  isLoading = false,
}: ConfirmModalProps) {
  const handleCancel = () => {
    onCancel?.();
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <ResponsiveModal open={open} onOpenChange={onOpenChange} title={title} contentClass="max-w-md" hideCloseButton>
      <div className="space-y-5">
        <div className="space-y-3">
          <h2 className="text-ds-text-primary text-lg font-semibold">{title}</h2>
          {description && (
            <p className="text-ds-text-subtle dark:text-ds-text-disabled text-sm leading-relaxed">{description}</p>
          )}
        </div>
        <div className="flex justify-end gap-3 pt-1">
          <Button variant="ghost" size="sm" onClick={handleCancel} disabled={isLoading}>
            {cancelText}
          </Button>
          <Button
            variant={variant === "destructive" ? "destructive" : "brand"}
            size="sm"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading && <PixelLoader size="xs" />}
            {confirmText}
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
}
